var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center","padding-top":"100px"}},[_c('van-loading',{staticStyle:{"margin":"auto"},attrs:{"color":"#1989fa","type":"spinner","size":"48"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }